<template>
    <div v-html="value.answer" />
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: true
        }
    }
};
</script>
